import { shopPrefix } from '../../../../../config';
import { http } from '../../../../../api/axios';
import { AccountOut } from '../../../../../store/api';

const endpoint = `${shopPrefix}/v1/shoppingcart/accounts/suggest`;

export const fetchCartAccountSuggestion = async () => {
    return http.get<{ suggestedAccount: AccountOut }>(endpoint).then(response => response.data.suggestedAccount);
};
